import React, { useEffect, useState } from 'react';
export function PromoBanner() {
  const messages = ['PROMO 50% OFF TODAY', 'FREE SHIPPING'];
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
    }, 3000); // Cambia cada 3 segundos
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-blue-900 text-white py-2.5 px-4 text-center font-bold overflow-hidden" data-id="element-326">
      <div className="relative h-6" data-id="element-327">
        {messages.map((message, index) => <div key={message} className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${index === currentIndex ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-328">
            <span className="text-base md:text-lg tracking-wide" data-id="element-329">
              {message}
            </span>
          </div>)}
      </div>
    </div>;
}